<template>

  <header v-if="process === 'signup'">
    <div class="grid-container">
      <img class="logo" src="../assets/images/global/logo.svg">
      <div class="link link-profile">
        <span class="image-circle">
          <img v-if="this.$root.profilereg.profileimg === 'default'" src="https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/profile-images%2Fdefaultimg1.jpg?alt=media&token=1704a992-1ea9-4c8d-a8c5-e4c59803155f" />
          <img v-else :src="this.$root.profilereg.profileimg" />
        </span>
        <span class="name">{{ this.$root.profilereg.firstname + ' ' + this.$root.profilereg.surname }}</span>
        <!-- <span class="reputation" :class="colorRep">{{ this.$root.userrep['.value'] }}</span> -->
        <!-- <span class="tooltip" :class="tooltip">Reputation</span> -->
      </div>
    </div>
  </header>

  <header v-else>
    <div class="grid-container">
      <img class="logo" src="../assets/images/global/logo.svg">
      <nav>
        <ul>
          <li><router-link class="link-simple fg-type" to="/matches">Matches</router-link></li>
          <li><router-link class="link-simple fg-type" to="/everyone">Everyone</router-link></li>
          <li><router-link class="link-simple fg-type" to="/favourites">Favourites</router-link></li>
          <li><router-link class="link-simple fg-type" to="/projects">Projects</router-link></li>
        </ul>
      </nav>
      <nav v-if="this.$root.profile.admin" class="admin">
        <ul>
          <li><router-link class="link-simple fg-type" to="/admin/overview">Stats</router-link></li>
          <li><router-link class="link-simple fg-type" to="/admin/site">Site Admin</router-link></li>
          <li><router-link class="link-simple fg-type" to="/admin/reports">Reports</router-link></li>
          <li><router-link class="link-simple fg-type" to="/tests">Tests</router-link></li>
        </ul>
      </nav>

      <div class="link link-profile" @click="toggleFunctions">
        <div class="image-circle">
          <img v-if="this.$root.profile.profileimg === 'default'" src="https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/profile-images%2Fdefaultimg1.jpg?alt=media&token=1704a992-1ea9-4c8d-a8c5-e4c59803155f" />
          <img :src="this.$root.profile.profileimg" />
        </div>
        <a class="name" :data-userid="this.$root.user.uid">{{ this.$root.profile.firstname + ' ' + this.$root.profile.surname }}</a>
        <!-- <span class="reputation" :class="colorRep">{{ this.$root.userrep['.value'] }}</span>
        <span class="tooltip">Reputation</span> -->
      </div>

      <a class="link-notification" @click="toggleNotifications" :class="{ notify: unreadNotifications }">Notifications</a>

      <router-link to="/chats" class="link-notification" :class="{ notify: chatNotify }">Chats</router-link>

      <div class="grid-container" id="notifications">
        <div class="list-box" :class="{ active: notificationsActive }">

          <notification-item :senderid="item.from" :message="item.content" :when="item.when" :link="item.link" :unread="item.unread" v-for="item in this.$root.notifications" :key="item['.key']"></notification-item>

          <span v-if="showTip" class="tip">No notifications</span>

        </div>
      </div>

      <div class="grid-container profile-functions" id="profile-functions">
        <div class="list-box profile" :class="{ active: functionsActive }">
            <div class="list-box-item">
              <router-link class="link-simple fg-type" :to="{ name: 'User Profile', params: { slug: this.$root.profile.slug}}">View Profile</router-link>
            </div>
            <div class="list-box-item">
              <router-link class="link-simple fg-type" to="/share">Share PEI.exCHANGE</router-link>
            </div>
<!--             <div class="list-box-item">
              <router-link class="link-simple fg-type" to="/logout">Change Password</router-link>
            </div> -->
            <div class="list-box-item">
              <router-link class="link-simple fg-type" to="/logout">Logout</router-link>
            </div>
        </div>
      </div>

    </div>
  </header>

</template>

<script>
import { db } from '@/firebase'
import ClickOutside from 'vue-click-outside'

import NotificationItem from '@/components/profile/NotificationItem'

export default {
  props: ['process', 'tooltip'],
  data () {
    return {
      unreads: null,
      notificationsActive: false,
      functionsActive: false
    }
  },
  components: {
    NotificationItem
  },
  computed: {
    chatNotify () {
      if (this.$root.profile.unreads) {
        var audio = new Audio('https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/notify-small.mp3?alt=media&token=8833aceb-1efb-4784-84c9-2d98b38b9f3a')
        audio.play()
        return true
      } else {
        return false
      }
    },
    unreadNotifications () {
      let nots = this.$root.notifications
      for (let i in nots) {
        if (nots[i].unread === true) {
          var audio = new Audio('https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/notification.mp3?alt=media&token=80dab0bd-131a-439c-8c68-e103887d5131')
          audio.play()
          return true
        }
      }
      return false
    },
    colorRep () {
      let rep = this.$root.userrep['.value']
      let c = null
      switch (true) {
        case (rep <= 10):
          break
        case (rep <= 11 && rep <= 20):
          c = 'color-11-20'
          break
        case (rep <= 21 && rep <= 30):
          c = 'color-21-30'
          break
        case (rep <= 31 && rep <= 40):
          c = 'color-31-40'
          break
        case (rep <= 41 && rep <= 50):
          c = 'color-41-50'
          break
        case (rep <= 51 && rep <= 60):
          c = 'color-51-60'
          break
        default:
          c = 'color-max'
          break
      }
      return c
    },
    showTip: function () {
      if (!Array.isArray(this.$root.notifications) || !this.$root.notifications.length) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    toggleNotifications () {
      if (this.notificationsActive) {
        let nots = this.$root.notifications
        this.keys = []
        for (let i in nots) {
          if (nots[i].unread === true) {
            let key = nots[i]['.key']
            db.ref('user-meta/notifications/' + this.$root.user.uid + '/' + key + '/unread').remove()
          }
        }

        this.notificationsActive = false
      } else {
        this.notificationsActive = true
      }
    },
    hideNotifications () {
      let nots = this.$root.notifications
      this.keys = []
      for (let i in nots) {
        if (nots[i].unread === true) {
          let key = nots[i]['.key']
          db.ref('user-meta/notifications/' + this.$root.user.uid + '/' + key + '/unread').remove()
        }
      }

      this.notificationsActive = false
    },
    toggleFunctions () {
      if (this.functionsActive) {
        this.functionsActive = false
      } else {
        this.functionsActive = true
      }
    },
    hideFunctions () {
      this.functionsActive = false
    }
  },
  directives: {
    ClickOutside
  },
  mounted () {
    // prevent click outside event with popupItem.
    this.popupItem = document.getElementById('notifications')
  }
}
</script>



// WEBPACK FOOTER //
// HeaderBar.vue?24246475